import axios from 'axios'
import React from 'react'
import './view-timesheet.css'
import ViewFamilyCard from './ViewFamilyCard/ViewFamilyCard'
import { baseUrl } from '../../assets/Animations'

const EditTimesheet = (props) => {
    const [families, setFamilies] = React.useState([])
    const [finalWarning, setFinalWarning] = React.useState(false)
    const [note, setNote] = React.useState('')
    const [notesOpen, setNotesOpen] = React.useState(false)
    const [estimatedPay, setEstimatedPay] = React.useState(0)
    const [listOfFamiliesForTeachers, setListOfFamiliesForTeachers] = React.useState([])
    const [incomplete, setIncomplete] = React.useState(false)
    const [monthNumber, setMonthNumber] = React.useState(props.openTimesheet.monthNumber)
    const [currentTimesheetNumber, setCurrentTimesheetNumber] = React.useState(0)


    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }



    let d = new Date()
    let theYear = d.getFullYear()
    let theMonthNumber = d.getMonth()

    React.useEffect(() => {
        calculateEstimatedPay()
        //createDateSettings()
        //console.log(props)
    },[])

    const calculateEstimatedPay = () => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < props.openTimesheet.families.length; i++) {
            let fam = props.openTimesheet.families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        setEstimatedPay(((minutesTaught/60) * Number(props.openTimesheet.teacherRate)) + allExtras)
    }

    const wrapperClickClose = (id) => {
        if(id === "create-timesheet-wrapper") {
            //props.setOpenUpTheTimesheet(false)
            props.setOpenTimesheet(false)
        }
    }

    return(
        <div className="view-timesheet-wrapper" id="create-timesheet-wrapper" onClick={(e) => wrapperClickClose(e.target.id)}>
            {/* {props.listOfTeachersTimesheetsForThisMonth.length > 1 && currentTimesheetNumber > 0 ? <div className='flip-backward-timesheet' onClick={() => setCurrentTimesheetNumber((prev) => prev - 1)} >BACK</div> : null} */}
            <div className="create-timesheet">
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => props.setOpenTimesheet(false)}>X</h3>
                </div>
                <h1>{props.openTimesheet.teacherName}</h1>
                <p className='create-timesheet__status-header' style={props.openTimesheet.status === 'submitted' ? {color: '#7e5611', backgroundColor: '#f5ddb3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'} : {color: '#117e18', backgroundColor: '#bcf5b3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'}}>{props.openTimesheet.status}</p>
                <h2>{props.openTimesheet.monthYear}</h2>
                <div className="family-card-section">
                    {props.openTimesheet.families.map((fam, index) => 
                        <ViewFamilyCard
                            key={fam.id}
                            index={index}
                            fam={fam}
                            reviewing={true}
                            month={monthNumber}
                        />
                    )}
                </div>
                <div className="create-timesheet-bottom-sections">
                    <p className="display-the-note"><strong>Note:</strong> {props.openTimesheet.note}</p>
                    {note !== '' && <div className="create-timesheet-pencil"></div>}
                    <h3 className="create-timesheet__estimated-pay">Estimate Pay: ${estimatedPay}</h3>
                    <div>
                       {/* <div className="admin-timesheet-submit-btn solid-red" onClick={() => deleteTimesheet(props.openTimesheet.timesheetId)}>Delete Timesheet</div>  */}
                       {/* <div className="admin-timesheet-submit-btn clear-green" onClick={() => saveAndCloseTimesheet()}>Save and close</div>  */}
                       {/* <div id="admin-timesheet-submit-btn-for-loading" className="admin-timesheet-submit-btn solid-green" onClick={() => saveAndSubmitTimesheet()}>Approve Timesheet</div>  */}
                    </div>
                </div>
            </div>
            {/* {props.listOfTeachersTimesheetsForThisMonth.length > 1 && currentTimesheetNumber + 1 < props.listOfTeachersTimesheetsForThisMonth.length ? <div className='flip-forward-timesheet' onClick={() => setCurrentTimesheetNumber((prev) => prev + 1)}>NEXT</div> : null} */}
        </div>
    )
}
export default EditTimesheet;